<template>
  <b-modal
    v-model="localIsActive"
    size="md"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @hide="onHide"
  >
    <template #modal-title>
      Historial de vista
    </template>

    <h5>{{ item.name }}</h5>
    <div class="history-card card">
      <div class="history-header d-flex align-items-center justify-content-end">
        <small class="text-muted">
          {{ item.validations.length }}
          {{ $t('custom_forms.entries') }}
        </small>
      </div>

      <div class="history-table">
        <div class="history-row history-row--head bg-transparent row mx-0">
          <div class="col-3 text-body">{{ $t('custom_forms.state') }}</div>
          <div class="col text-body">{{ $t('custom_forms.user') }}</div>
          <div class="col text-body">{{ $t('custom_forms.date') }}</div>
        </div>

        <div class="history-body">
          <div
            v-for="s in item.validations"
            :key="s.id"
            class="history-row-item-container"
          >
            <div class="history-row-item row mx-0">
              <div class="col-3">
                <b-badge pill :variant="getStatusVariant(s.status.name)" class="history-badge">
                  {{ getStatusLabel(s.status.name) }}
                </b-badge>
              </div>
              <div class="col">
                <div class="history-user" :title="formatUser(s)">
                  <div class="user-name text-body">{{ getUserName(s) || '—' }}</div>
                  <div v-if="getUserEmail(s)" class="user-email text-body">
                    {{ getUserEmail(s) }}
                  </div>
                </div>
              </div>
              <div class="col-4">
                <small class="history-date text-body">
                  {{ formatDate(s.approved_at || s.rejected_at || s.reopened_at || s.created_at) }}
                </small>
              </div>
            </div>
            <div class="history-row-item__comments">
              {{ s.comments || s.reopened_comments }}
            </div>
          </div>
        </div>
      </div>
      </div>
  </b-modal>
</template>

<script>
import { computed } from '@vue/composition-api';
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  props:{
    item: {
      type: Object
    },
    showModalHistory:{
      type: Boolean
    }
  },
  setup (props, { emit }) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    //DATA
    const statusesByValidator = ['approved','commented','rejected'];

    //COMPUTED
    const localIsActive = computed({
      get() {
        return props.showModalHistory;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    //METHODS
    const formatDate = (iso) => {
      if (!iso) return '';
      try {
        const d = new Date(iso);
        return d.toLocaleString();
      } catch {
        return iso;
      }
    }

    const formatUser = (s) => {
      const { name:nameStatus } = s.status;
      const historicalUser      = (statusesByValidator.includes(nameStatus)) ? s.user_validation : s.user_created;
      const name                = (historicalUser) ? historicalUser.user : '-';
      const email               = (historicalUser) ? historicalUser.email : '-';

      return [name, email].filter(Boolean).join(' | ');
    }

    const getStatusLabel = (status) => {
      if (!status) return "-";

      return t(`operational_security.evaluation.status.${status}`);
    }

    const getStatusVariant = (status) => {
      if (!status) return "secondary";

      const statusVariants = {
        in_progress: "primary",
        in_review: "info",
        rejected: "danger",
        commented: "warning",
        approved: "success",
        updated: "dark"
      };

      return statusVariants[status] || "secondary";
    }

    const getUserEmail = (s) => {
      const { name:nameStatus } = s.status;
      const historicalUser      = (statusesByValidator.includes(nameStatus)) ? s.user_validation : s.user_created;

      return (historicalUser) ? historicalUser.email : '-';
    }

    const  getUserName = (s) => {
      const { name:nameStatus } = s.status;
      const historicalUser      = (statusesByValidator.includes(nameStatus)) ? s.user_validation : s.user_created;

      return (historicalUser) ? historicalUser.user : '-';
    }

    const onHide = () => {
      emit('update:isActive', false);
    }

    return {
      localIsActive,

      formatDate,
      formatUser,
      getStatusLabel,
      getStatusVariant,
      getUserEmail,
      getUserName,
      onHide
    }
  }
}
</script>

<style lang="scss" scoped>
.history-card { background: #fff; border: 1px solid #eceff3; border-radius: 8px; padding: 12px; overflow: hidden; min-width: 300px; }
.history-header { margin-bottom: 8px; }
.history-table { width: 100%; }
/* .history-row { display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;} */
.history-row-item-container {
  border-bottom: 1px dotted #e0e0e0;
}
.history-row-item {
  padding: 10px 0;
}
.history-row-item__comments {
  font-size: 16px;
}
.history-body {
  max-height: 400px;
  overflow-y: auto;
}
.history-row:last-child { border-bottom: 0; }
.history-row--head { border-bottom: 1px solid #e9ecef; font-weight: 600; color: #444; padding-top: 0; padding-bottom: 8px; }
.col-state { justify-self: start; }
.col-user { justify-self: start; min-width: 0; }
.col-date { justify-self: end; white-space: nowrap; overflow: visible; }
.history-row--head > div, .history-row > .col-user { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.col-note { white-space: normal; overflow: hidden; }
.history-badge { display: inline-flex; align-items: center; }
.history-date { font-size: 12px; color: #6c757d; font-variant-numeric: tabular-nums; }
.content-grid { display: block; }
</style>
